import { openShareDocument } from './share-ios.js';
import { openShareWx } from './share-wx.js';
import { type FabricShareDocumentApi, type FabricShareWxApi } from './types.js';

/**
 * Share API
 * @interface
 */
export type FabricShareApi = {
  /**
   * 微信分享
   */
  openShareWx: FabricShareWxApi;
  /**
   * IOS文件分享
   */
  openShareDocument: FabricShareDocumentApi;
};

export const fabricShare: FabricShareApi = {
  openShareWx,
  openShareDocument,
};
